// An intersection observer for all elements with classes that start with "animate__".
// When visible in the viewport, the class "animate__animated" is added to the element.
// Only runs on Bootstrap's LG breakpoint (992px) and up.

const lgBreakpoint = 992;

const observerOptions = {
  threshold: 0  // Adjust the threshold as needed
};

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {

    let animation = entry.target.dataset.animate;

    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('animate__' + animation);
      entry.target.classList.add('animate__animated');
    }
    // Uncomment this block if you want the animation to be removed when the element is not visible
    // else {
    //   entry.target.classList.remove('animate__' + animation);
    //   entry.target.classList.remove('animate__animated');
    // }
  });
}, observerOptions);

// Only set up observer on LG breakpoint and up
if (window.innerWidth >= lgBreakpoint) {
  document.querySelectorAll('[data-animate]').forEach(element => {
    observer.observe(element);
  });
}
